import React, { ReactNode } from "react";
import { Cross2Icon } from "@radix-ui/react-icons";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { blackA } from "@radix-ui/colors";
import { Col, Div, DivProps } from "@/styles/layout";
import { Body } from "@/styles/typography";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  border,
  color,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
} from "styled-system";
import { BsXCircle } from "react-icons/bs";

const StyledContent = styled(DialogPrimitive.Content)<DivProps>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 80vh;
  overflow: auto;
  border-radius: 0px;

  ${color}
  ${space}
  ${layout}
  ${flexbox}
  ${position}
  ${border}
  ${typography}
  ${shadow}  
  ${grid}
`;

const StyledOverlay = styled(DialogPrimitive.Overlay)<DivProps>`
  background-color: ${blackA.blackA1};
  position: fixed;
  inset: 0;
  ${color}
  ${space}
  ${layout}
  ${flexbox}
  ${position}
  ${border}
  ${typography}
  ${shadow}  
  ${grid}
`;

interface Props {
  trigger?: ReactNode;
  children: ReactNode;
  open: boolean;
  onOpenChange: (o: boolean) => void;
}

export const Dialog = ({
  open,
  onOpenChange,
  trigger,

  children,
}: Props) => {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      {!!trigger && (
        <DialogPrimitive.Trigger asChild>{trigger}</DialogPrimitive.Trigger>
      )}
      <DialogPrimitive.Portal>
        <StyledOverlay width="100vw" height="100vh" bg="overlay.9" />
        <StyledContent>
          <div className="bg-white rounded-sm  min-w-[340px] relative">
            <div
              className="absolute top-2 right-2 hover:cursor-pointer"
              onClick={() => onOpenChange(false)}
            >
              <BsXCircle size={20} />
            </div>

            {children}
          </div>
        </StyledContent>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};
